import { render, staticRenderFns } from "./campaignsBarChart.vue?vue&type=template&id=9bc4d002&scoped=true"
import script from "./campaignsBarChart.vue?vue&type=script&lang=js"
export * from "./campaignsBarChart.vue?vue&type=script&lang=js"
import style0 from "./campaignsBarChart.vue?vue&type=style&index=0&id=9bc4d002&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bc4d002",
  null
  
)

export default component.exports